import React from 'react'
import SearchIcon from '../../assets/icons/search.svg'
import styles from './SearchInput.module.css'

const SearchInput = (props) => {
  return (
    <div className={styles.searchCont}>
        <span><img src={SearchIcon} alt="Search Icon"/></span>
          <span><input type='text' placeholder={props.placeholder}/></span>
    </div>
  )
}

export default SearchInput